import { useContext } from 'react';
import { UsersApiContext } from './UsersApiContext';
import type { UsersApiClient } from './types';

export function useUsersApiClient(): UsersApiClient {
  const client = useContext(UsersApiContext);
  if (client === null) {
    throw new Error(
      'useUsersApiClient: no UsersApiProvider in the tree. ' +
        'Wrap the consumer in <UsersApiProvider client={...}>.',
    );
  }
  return client;
}
